import { IHttpClient } from '@/core/services/http'
import { ForgotPasswordDto } from '../types/dtos/forgot-password.dto'

export function createForgotPasswordUseCase({
  httpClient,
}: {
  httpClient: IHttpClient
}) {
  return async function (credentials: ForgotPasswordDto) {
    await httpClient
      .version('v1')
      .post('/website/buyer/forget-password', credentials)
  }
}
